import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="max-w-3xl mx-auto px-4 md:px-6 pt-6 pb-6 md:pt-14 md:pb-16 text-center" data-id="element-133">
      <FadeIn data-id="element-134">
        <h1 className="text-[1.45rem] md:text-6xl font-extrabold text-brown-900 tracking-tight mb-1 md:mb-4 leading-tight whitespace-nowrap" data-id="element-135">
          Before You Pay That Medical Bill…
        </h1>
        <p className="text-base md:text-3xl font-bold text-terracotta-600 mb-2 md:mb-4 leading-snug" data-id="element-136">
          Take 5 Minutes To Check This First
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-137">
        <p className="max-w-xl mx-auto mb-2 md:mb-3 text-sm md:text-lg text-brown-800 leading-relaxed" data-id="element-138">
          Many moms are surprised to discover duplicate charges, confusing
          billing codes, or unexpected fees on their family's medical bills.
        </p>
        <p className="max-w-xl mx-auto mb-2 md:mb-3 text-sm md:text-lg text-brown-800 leading-relaxed" data-id="element-139">
          This quick guide shows you how to review your bill, spot potential
          issues, and ask the right questions before paying. You don't need to
          argue. You need a structure.
        </p>
        <p className="max-w-xl mx-auto mb-3 md:mb-4 text-sm md:text-lg text-terracotta-600 leading-relaxed font-semibold" data-id="element-140">
          You can read it in about 10 minutes and start reviewing your bill
          today.
        </p>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-141">
        <div className="relative mx-auto max-w-[220px] md:max-w-sm shadow-2xl rounded-lg overflow-hidden mb-4 md:mb-5" data-id="element-142">
          <img src="https://cdn.magicpatterns.com/uploads/oAmUMx8hxSmZppAwH3vM1B/Image_for_mockup_Original.png" alt="Stop Overpaying Medical Bills Ebook Cover" className="w-full h-auto" width={384} height={497} fetchPriority="high" decoding="async" data-id="element-143" />
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-144">
        <button onClick={() => {
        const el = document.getElementById('final-cta');
        if (el) el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }} className="inline-flex items-center justify-center px-7 py-4 md:px-8 md:py-5 text-base md:text-xl font-bold text-white bg-terracotta-500 rounded-full shadow-lg hover:bg-terracotta-600 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 group" data-id="element-145">
          Get Instant Access
        </button>
        <p className="mt-2 text-xs md:text-sm text-brown-500" data-id="element-146">
          Instant digital download • Read on any device
        </p>
      </FadeIn>
    </section>;
}